<div class="modal modal_size_744 modal__opened">
  <div class="modal__close icon icon-close" (click)="close()"></div>

  <ng-container [ngTemplateOutlet]="subscriptionsSelect" *ngIf="!purchasing else loader"></ng-container>
</div>

<ng-template #subscriptionsSelect>
  <ng-container>
    <div class="modal__container">
      <div class="modal__title modal__title-mb24 h2">{{ 'purchase-modal.subscription-choose-title' | translate }}</div>
      <div class="modal__content">
        <div class="modal__plan">
          <div class="modal-plan modal-plan_type_recommended" [class.modal-plan_type_selected]="privetPlusPurchase" (click)="privetPlusPurchase = true">
            <div class="modal-plan__recommended">{{ 'purchase-modal.recommendation' | translate }}</div>
            <div class="modal-plan__title">{{ 'purchase-modal.try-privet-plus-title' | translate }}</div>
            <div class="modal-plan__text">{{ 'purchase-modal.try-privet-plus-text' | translate }}</div>
            <div class="modal-plan__price" [innerHTML]="'purchase-modal.try-privet-plus-price' | translate"></div>
            <div class="modal-plan__price-hint" [innerHTML]="'purchase-modal.free-day' | translate"></div>
          </div>
        </div>
        <div class="modal__plan" *ngIf="!privet">
          <div class="modal-plan" [class.modal-plan_type_selected]="!privetPlusPurchase" (click)="privetPlusPurchase = false">
            <div class="modal-plan__title">{{ 'purchase-modal.without-privet-plus-title' | translate }}</div>
            <div class="modal-plan__text">{{ 'purchase-modal.without-privet-plus-text' | translate }}</div>
            <div class="modal-plan__price" [innerHTML]="'purchase-modal.without-privet-plus-price-choose-modal' | translate "></div>
            <div class="modal-plan__price-hint" [innerHTML]="'purchase-modal.free-day-privet' | translate "></div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" (click)="buySubscriptions()">{{ 'purchase-modal.purchase' | translate }}</div>
    </div>
  </ng-container>
</ng-template>

<ng-template #loader>
  <ng-container *ngIf="requestInProgress else subscriptionRequestSent">
    <div class="modal__container modal__container-center">
      <div class="modal__loader with-icon"></div>
    </div>
  </ng-container>
</ng-template>

<ng-template #subscriptionRequestSent>
  <ng-container *ngIf="!wrongServiceError else wrongService">
    <div class="modal__close icon icon-close" (click)="close()"></div>
    <div class="modal__container">
      <div class="modal__img">
        <div class="modal-img modal-img_name_congratulations modal-img_size_192"></div>
      </div>
      <div class="modal__title modal__title-mb12 h2" *ngIf="!privetPlusPurchase">{{ 'activate-subscription-modal.connecting-privet' | translate }}</div>
      <div class="modal__title modal__title-mb12 h2" *ngIf="privetPlusPurchase">{{ 'activate-subscription-modal.connecting-privet-plus' | translate }}</div>
      <div class="modal__text">{{ 'activate-subscription-modal.connecting-text' | translate }}</div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" (click)="close()">{{ 'activate-subscription-modal.ok-button' | translate }}</div>
    </div>
  </ng-container>
</ng-template>

<ng-template #wrongService>
  <div class="modal__img">
    <div class="modal-img modal-img_name_whistling modal-img_size_192"></div>
  </div>
  <div class="modal__title modal__title-mb12 h2">{{ 'activate-subscription-modal.error' | translate }}</div>
  <div class="modal__text">{{ 'activate-subscription-modal.corp-subscriber' | translate }}</div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button button_type_light" (click)="close()">{{ 'purchase-modal.ok-button' | translate }}</div>
  </div>
</ng-template>

